import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { MainService } from 'src/app/services/main.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-modal-view-objective',
  templateUrl: './modal-view-objective.component.html',
  styleUrls: ['./modal-view-objective.component.scss']
})
export class ModalViewObjectiveComponent implements OnInit {

  // Definimos el FormGroup con los campos reales de la meta
  objectiveForm: FormGroup = new FormGroup({
    name: new FormControl(''),
    start_date: new FormControl(''),
    end_date: new FormControl(''),
    objective: new FormControl(''),
    achieved_objective: new FormControl(''),
    user_name: new FormControl('')
  });

  constructor(
    private uService: UtilsService,
    public dialogRef: MatDialogRef<ModalViewObjectiveComponent>,
    private mService: MainService, 
    private toast: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log(this.data, 'data recibida en el modal');

    // Mapeamos los datos que vienen directo de la fila seleccionada
    // Mapeamos los datos que vienen directo de la fila seleccionada
    if (this.data) {
      this.objectiveForm.get('name')?.setValue(this.data.name);
      this.objectiveForm.get('start_date')?.setValue(this.data.start_date);
      this.objectiveForm.get('end_date')?.setValue(this.data.end_date);
      this.objectiveForm.get('objective')?.setValue(this.data.objective);
      this.objectiveForm.get('achieved_objective')?.setValue(this.data.achieved_objective || '---');
      this.objectiveForm.get('user_name')?.setValue(this.data.user_name || 'Sin asignar');
    }
  }

  ngOnInit(): void {
  }

  dismiss() {
    this.dialogRef.close(null);
  }
}